/* eslint-disable */
import { produce } from "immer";
import {
  GET_TITLE_FETCH_START,
  GET_TITLE_FETCH_SUCCESS,
  GET_TITLE_FETCH_FAILURE,
} from "../actions/types";

const getTitleReducer = (
  state = {
    TitleFetching: false,
    titleData: [],
    titleError: null,
  },
  action,
) => {
  switch (action.type) {
    case GET_TITLE_FETCH_START:
      return produce(state, (draft) => {
        draft.TitleFetching = true;
      });
    case GET_TITLE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.TitleFetching = true;
        draft.titleData = action.data;
        draft.TitleFetching = false;
      });
    case GET_TITLE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.TitleFetching = false;
        draft.titleError = action.error;
      });
    default:
      return state;
  }
};

export default getTitleReducer;
